import React, { useEffect, useState } from 'react';
import { Modal, Button, FloatingLabel } from 'react-bootstrap';
import { FaExclamationTriangle, FaBell, FaTimes, FaCheck  } from 'react-icons/fa';
import Form from 'react-bootstrap/Form';
import { authenticationService } from '../../../../service/authentication';
import { useTranslation } from 'react-i18next';

interface Notification {
  id: number;
  caption: string;
  notification_type: string;
  updatedAt: string;
  content: string;
  typeButton : string;
  type: any;
}

interface NotificationModalProps {
  show: boolean;
  notifications: Notification[];
  onClose: () => void;
  onSnooze: (id: number) => void;
  typeButton: string;
  onScroll: (e: React.UIEvent<HTMLDivElement>) => void;
  hasMore: boolean;
  isLoading: boolean;
}

const NotificationModal: React.FC<NotificationModalProps> = ({
  show,
  notifications,
  onClose,
  onSnooze,
  typeButton,
  onScroll,
  hasMore,
  isLoading
}) => {

  const { t } = useTranslation();


  const [showSecondaryModal, setShowSecondaryModal] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState<any>(null);
  const [showNotifyCloseModal, setShowNotifyCloseModal] = useState(false);
  const [notificationId, setNotificationId] = useState("")
  const [notificationRemark, setNotificationRemark] = useState("")
  const [userId, setUserId] = useState("");




  const handleCloseSecondaryModal = () => {
    setShowSecondaryModal(false);
    setSelectedNotification(null);
  };

  const onView = async (id: number) => {
    const notification = notifications.find(n => n.id === id);
    if (notification) {
      setSelectedNotification(notification);
      setShowSecondaryModal(true);
      // Update notification status when modal opens
      await updateNotification("completed", id.toString());
    }
  };

  const onDismiss = (id: any) => {
    setShowNotifyCloseModal(true)
    setNotificationId(id)
  }

  const updateNotification = async (completedStatus: string, notificationId: string) => {
    const dataToSend = {
      id : notificationId,
      read_status:"1",
      complete_status: completedStatus,
      user_id: userId
    }

    try {
      const response = await authenticationService.updateNotification(dataToSend);
      if(response.status && response.statusCode === 200){
        // Notification updated successfully, but we're not closing the modal
        // The modal will close only when the user clicks the close or cancel button
      } else {
        // Handle error case if needed
      }
    } catch (error) {
      console.error('user response', error);
    }
  }

  const handleCloseNotifyDetailsCloseModal = () => {
    setShowSecondaryModal(false);
    setSelectedNotification(null);
  }

  const handleCloseNotifyCloseModal = () => {
    setShowNotifyCloseModal(false)
    setNotificationRemark("")
  }

  const handleNotifiCloseSubmit = async () => {
    const dataToSend = {
      "notification_id" : notificationId, 
      "user_remark":notificationRemark
    }
    try {
      const response = await authenticationService.updateNotificationRemark(dataToSend);
      if (response.status && response.statusCode === 200) {
        handleCloseNotifyCloseModal()
      } else {
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  interface NotificationContentProps {
    content: string;
    // interface NotificationContentProps {
    // content: string;
  //}
  }

  const NotificationContent: React.FC<NotificationContentProps> = ({ content }) => {
    if (!content) return null;
  
    // const contentItems = content.split('<br>');
  
    // return (
    //   <div className=''>
    //     <ul style={{ listStyleType: 'circle', textAlign: 'left' }}>
    //       {contentItems.map((item : any, index: number) => (
    //         <li key={index} className='normalText2'>{item}</li>
    //       ))}
    //     </ul>
    //   </div>
    // );
    
    // First split by <br> to get main sections
    const sections = content.split('<br>').filter(section => section.trim() !== '');
    
    return (
      <div className='' style={{ textAlign: 'left' }}>
        <ul style={{ listStyleType: 'circle', paddingLeft: '20px', margin: '0' }}>
          {sections.map((section, sectionIndex) => {
            // For each section, further split by /n to handle plate information
            const items = section.split('/n').filter(item => item.trim() !== '');
            
            return items.map((item, itemIndex) => {
              const key = `${sectionIndex}-${itemIndex}`;
              return (
                <React.Fragment key={key}>
                  <li className='normalText2' style={{ marginBottom: '5px' }}>
                    {item.trim()}
                  </li>
                  {itemIndex < items.length - 1 && <br />}
                </React.Fragment>
              );
            });
          })}
        </ul>
      </div>
    );
  };

  useEffect(() => {
    var storedData = localStorage.getItem('userDetails');

    if(storedData) {
      var storedObject = JSON.parse(storedData);
      setUserId(storedObject[0].id)
    }

  }, [])



  return (
    <>
    <Modal show={show} onHide={onClose} className="top-right-modal">
      <Modal.Header closeButton>
        <Modal.Title>Notifications</Modal.Title>
      </Modal.Header>
      <Modal.Body 
        className='alert-content'
        onScroll={onScroll}
      >
        {notifications?.map((obj: any, index) => (
          <div key={obj?.id} className="notification-item">
            <div className="notification-image">
              {obj.notification_type === 'alarm' ? (
                <FaBell className="ringing-icon" style={{ color: 'orange', marginRight: '5px', marginLeft: '5px'}} size={20} />
              ) : obj.notification_type === 'info' ? (
                <FaCheck style={{ color: 'green', marginRight: '5px', marginLeft: '5px' }} size={20} />
              ) : (
                <FaExclamationTriangle style={{ color: 'red', marginRight: '5px', marginLeft: '5px' }} size={20} />
              )}
            </div>
            <div className="notification-details">
              <p className="notification-name">{obj?.caption}</p>
              <p className="notification-date">{obj?.updatedAt}</p>
              <div className="buttons-container">
                <button onClick={() => onView(obj?.id)} className="view-button">View</button>
                {typeButton === 'PopupClicked' && (
                <Button variant="secondary" size="sm" onClick={() => onSnooze(obj?.id)} className="button">
                  Snooze
                </Button>
                )}
                <Button variant="danger" size="sm" onClick={() => onDismiss(obj?.id)} className="button">
                  Close
                </Button>
              </div>
            </div>
          </div>
        ))}
        {isLoading && (
          <div className="text-center my-2">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        {!hasMore && notifications.length > 0 && (
          <div className="text-center my-2 text-muted">
            No more notifications to show
          </div>
        )}
      </Modal.Body>
      {/* <div className="bottomArea">
      <button onClick={onClose} className="modalCancelBtn">Cancel</button>
      </div> */}
    </Modal>

    {selectedNotification && (
      <Modal 
        show={showSecondaryModal} 
        className="top-center-modal" 
        onHide={handleCloseNotifyDetailsCloseModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Notification Details</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '80vh', overflowY: 'auto' }}>
          <div className='my-2'>
            <NotificationContent content={selectedNotification?.content} />
          </div>
        </Modal.Body>
        <div className="bottomArea">
          <button onClick={handleCloseNotifyDetailsCloseModal} className="modalCancelBtn">Cancel</button>
        </div>
      </Modal>
    )}

      <Modal show={showNotifyCloseModal} centered >
        <Modal.Header closeButton onClick={() => handleCloseNotifyCloseModal()}>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloatingLabel
            controlId="floatingTextarea"
            label="Please add a remark"
            className="mb-3"
          >
            <Form.Control 
              as="textarea" 
              placeholder="Leave a comment here" 
              style={{ maxHeight: '150px' }}
              value={notificationRemark}
              onChange={(e) => setNotificationRemark(e.target.value)}
            />
          </FloatingLabel>
        </Modal.Body>
          <div className="d-flex justify-content-between m-2">
            <button
              onClick={() => handleCloseNotifyCloseModal()}
              className="modalCancelBtn"
            >
              {t("buttons.cancel")}
            </button>
            <button
              onClick={() => handleNotifiCloseSubmit()}
              className="squareOrangeBtn3"
              disabled={!notificationRemark}
            >
              {t("buttons.submit")}
            </button>
          </div>
      </Modal>
   
    </>


  );
};

export default NotificationModal;
